interface StreamEventProduct {
  id: string;
  title: string;
  eventCancel?: { startedAt: unknown } | null;
}

/**
 * Пункты меню «Отменить событие» у эфира: только PPV, отмена которых ещё не
 * начата. Уже отменённый продукт в меню не попадает (окно для него всё
 * равно закрылось бы ошибкой «Событие уже отменено»).
 */
export const getCancellableEventProducts = (
  products: readonly (StreamEventProduct | null | undefined)[]
): { id: string; title: string }[] =>
  products
    .filter((product): product is StreamEventProduct =>
      Boolean(product && !product.eventCancel)
    )
    .map(({ id, title }) => ({ id, title }));
